// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledActionsWrap, StyledActionButton } from './BannersTableActionsStyles';
import { EditIcon, TrashIcon } from '@/icons';
import { COLORS } from '@/theme';

// Models
import { IBanner } from '@/models/banners.model';

type TBannersTableActions = {
  record: IBanner;
  handleEditClick: (banner: IBanner) => void;
  setBannerForDelete: (banner: IBanner) => void;
};

const BannersTableActions = ({ handleEditClick, setBannerForDelete, record }: TBannersTableActions) => {
  const { t } = useTranslation(['banners']);

  const handleDelete = () => setBannerForDelete(record);
  const handleEdit = () => handleEditClick(record);

  return (
    <StyledActionsWrap>
      <StyledActionButton $color={COLORS.PALE_YELLOW} onClick={handleEdit}>
        <EditIcon />
        {t('banners_list_edit')}
      </StyledActionButton>
      <StyledActionButton $color={COLORS.RED} onClick={handleDelete}>
        <TrashIcon />
      </StyledActionButton>
    </StyledActionsWrap>
  );
};

export default BannersTableActions;
